"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var BringgDashboardSDK_1 = require("../../BringgDashboardSDK");
var object_merger_1 = require("../../Data/object-merger");
var data_store_1 = __importDefault(require("../../data-store"));
var storable_data_service_1 = __importDefault(require("../../storable-data-service"));
var TagEntity_1 = __importDefault(require("../Entity/TagEntity"));
var tagIdGroup = 'tagIds';
var TagsApi = /** @class */ (function () {
    function TagsApi(session) {
        var _this = this;
        this.updateConfigurationStore = function (store, tagId, configuration) {
            if (configuration) {
                store.set(configuration);
            }
            else {
                _this.removeConfigurationByTagId(store, tagId);
            }
        };
        this.removeAllConfigurationsByTagId = function (tagId) {
            [
                _this.tagMerchantConfigurationsStore,
                _this.tagCustomerConfigurationsStore,
                _this.tagRulesConfigurationsStore
            ].forEach(function (store) {
                _this.removeConfigurationByTagId(store, tagId);
            });
        };
        this.removeConfigurationByTagId = function (store, tagId) {
            store.getGroup(tagIdGroup, tagId).forEach(function (_a) {
                var id = _a.id;
                return store.remove(id);
            });
        };
        this.tagsEntity = new TagEntity_1.default(session);
        this.tagsStore = new data_store_1.default();
        this.tagMerchantConfigurationsStore = new data_store_1.default([
            {
                groupType: tagIdGroup,
                keyFunc: function (tagMerchantConfiguration) { return tagMerchantConfiguration.tag_id; }
            }
        ]);
        this.tagCustomerConfigurationsStore = new data_store_1.default([
            {
                groupType: tagIdGroup,
                keyFunc: function (tagCustomerConfiguration) { return tagCustomerConfiguration.tag_id; }
            }
        ]);
        this.tagRulesConfigurationsStore = new data_store_1.default([
            {
                groupType: tagIdGroup,
                keyFunc: function (tagRulesConfiguration) { return tagRulesConfiguration.tag_id; }
            }
        ]);
        var mapper = function (tagConfiguration) {
            var tagMerchantConfiguration = tagConfiguration.tag_merchant_configuration, tagCustomerConfiguration = tagConfiguration.tag_customer_configuration, tagRulesConfiguration = tagConfiguration.tag_rules_configuration, tagStoreContent = __rest(tagConfiguration, ["tag_merchant_configuration", "tag_customer_configuration", "tag_rules_configuration"]);
            var existing = _this.tagsStore.get(tagStoreContent.id);
            _this.updateConfigurationStore(_this.tagMerchantConfigurationsStore, tagStoreContent.id, tagMerchantConfiguration);
            _this.updateConfigurationStore(_this.tagCustomerConfigurationsStore, tagStoreContent.id, tagCustomerConfiguration);
            _this.updateConfigurationStore(_this.tagRulesConfigurationsStore, tagStoreContent.id, tagRulesConfiguration);
            if (existing) {
                var previous = (0, BringgDashboardSDK_1.getGlobals)().mobx.toJS(existing);
                var diff = object_merger_1.objectMerger.deepMerge(previous, tagStoreContent);
                return { current: tagStoreContent, diff: diff };
            }
            else {
                return { current: tagStoreContent };
            }
        };
        this.tagsStorableDataService = new storable_data_service_1.default(this.tagsStore, mapper);
    }
    TagsApi.prototype.getTag = function (id) {
        return this.tagsStore.get(id);
    };
    TagsApi.prototype.getTagMerchantConfiguration = function (tagId) {
        var _a;
        return (_a = this.tagMerchantConfigurationsStore.getGroup(tagIdGroup, tagId)) === null || _a === void 0 ? void 0 : _a[0];
    };
    TagsApi.prototype.getTagCustomerConfiguration = function (tagId) {
        var _a;
        return (_a = this.tagCustomerConfigurationsStore.getGroup(tagIdGroup, tagId)) === null || _a === void 0 ? void 0 : _a[0];
    };
    TagsApi.prototype.getTagRulesConfiguration = function (tagId) {
        var _a;
        return (_a = this.tagRulesConfigurationsStore.getGroup(tagIdGroup, tagId)) === null || _a === void 0 ? void 0 : _a[0];
    };
    TagsApi.prototype.loadAll = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.tagsStorableDataService.loadAll('loadAll', function () { return __awaiter(_this, void 0, void 0, function () {
                            var response;
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0: return [4 /*yield*/, this.tagsEntity.service.getAll()];
                                    case 1:
                                        response = _a.sent();
                                        return [2 /*return*/, response.tags];
                                }
                            });
                        }); })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    TagsApi.prototype.update = function (id, options) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.tagsStorableDataService.modify('update', function () { return __awaiter(_this, void 0, void 0, function () {
                            var response;
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0: return [4 /*yield*/, this.tagsEntity.service.update(id, options)];
                                    case 1:
                                        response = _a.sent();
                                        return [2 /*return*/, response.tag];
                                }
                            });
                        }); })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    TagsApi.prototype.create = function (options) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.tagsStorableDataService.modify('create', function () { return __awaiter(_this, void 0, void 0, function () {
                            var response;
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0: return [4 /*yield*/, this.tagsEntity.service.create(options)];
                                    case 1:
                                        response = _a.sent();
                                        return [2 /*return*/, response.tag];
                                }
                            });
                        }); })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    TagsApi.prototype.delete = function (id) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.tagsStorableDataService.delete('delete', function () { return _this.tagsEntity.service.delete(id); }, id)];
                    case 1:
                        _a.sent();
                        this.removeAllConfigurationsByTagId(id);
                        return [2 /*return*/];
                }
            });
        });
    };
    return TagsApi;
}());
exports.default = TagsApi;
//# sourceMappingURL=tags-api.js.map